import { usePageTitle } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { useDispatch } from 'react-redux'

import LoadingState from 'components/core/loading_state'
import { useHomeTabs } from 'hooks/home/tabs'
import { useGetOwnersListQuery } from 'services/workflows/api'

import { convertScopeType } from './helpers'
import { WithLoadingState } from './loading_state'
import { ListWrapper } from '../styles/layout'
import { MyCalendlyList } from './scopes/my_calendly_list'
import { SingleOwnerList } from './scopes/single_owner_list'

const Contents = () => {
  const { getTabScopeV1 } = useHomeTabs()
  const scope = getTabScopeV1()
  switch (scope.type) {
    case 'my_calendly':
      return <MyCalendlyList />
    default: return (
      <SingleOwnerList />
    )
  }
}

export const List = () => {
  usePageTitle(`${I18n.t('publisher.home.tabs.workflows')} - Calendly`)
  const dispatch = useDispatch()
  const { getTabScopeV1, setTabScopeV1 } = useHomeTabs()
  const scope = getTabScopeV1()
  const { isFetching, isSuccess: hasOwnerListPermissions } = useGetOwnersListQuery(
    { owner_id: scope.id, owner_type: convertScopeType(scope.type) }
  )

  if (!isFetching && !hasOwnerListPermissions) {
    dispatch(setTabScopeV1({ type: 'my_calendly' }))
  }

  if (isFetching) {
    return <LoadingState />
  }

  return (
    <WithLoadingState>
      <ListWrapper>
        <Contents />
      </ListWrapper>
    </WithLoadingState>
  )
}
